const CancelSubscriptionScreenViewed = {
  object_name: 'cancelSubscription',
  screen: 'cancelSubscription',
  screen_name: 'cancelSubscription',
  origin: 'cancelSubscription',
}

const CancelSubscriptionConfirmationScreenViewed = {
  object_name: 'cancelSubscriptionConfirmationScreen',
  screen: 'cancelSubscriptionConfirmationScreen',
  screen_name: 'cancelSubscriptionConfirmationScreen',
  origin: 'cancelSubscription',
}
const CancelSubscriptionGetStartedButtonTapped = {
  object_name: 'cancelSubscriptionCTA',
  screen: 'cancelSubscription',
  screen_name: 'cancelSubscription',
  cta_title: 'Get started',
  origin: 'cancelSubscription',
}

const CancelSubscriptionConfirmationButtonTapped = {
  object_name: 'cancelSubscriptionConfirmationCTA',
  screen: 'cancelSubscriptionConfirmation',
  screen_name: 'cancelSubscriptionConfirmation',
  cta_title: 'Withdraw and request closure',
  origin: 'cancelSubscription',
}

const CancelSubscriptionCancelButtonTapped = {
  object_name: 'CancelSubscriptionConfirmationCancel',
  screen: 'cancelSubscriptionConfirmation',
  screen_name: 'cancelSubscriptionConfirmation',
  cta_title: 'Never mind',
  origin: 'cancelSubscription',
}

const CancelSubscriptionConfirmButtonTapped = {
  object_name: 'CancelSubscriptionConfirmationConfirm',
  screen: 'cancelSubscriptionConfirmation',
  screen_name: 'cancelSubscriptionConfirmation',
  cta_title: 'Continue',
  origin: 'cancelSubscription',
}

const CancelSubscriptionDoneScreenViewed = (tier: string) => ({
  object_name: 'cancelSubscriptionDone',
  screen: 'cancelSubscriptionDone',
  screen_name: 'cancelSubscriptionDone',
  previous_tier: tier,
  origin: 'cancelSubscription',
})

const CancelSubscriptionDoneCTA = {
  object_name: 'cancelSubscriptionDoneCTA',
  screen: 'cancelSubscriptionDone',
  screen_name: 'cancelSubscriptionDone',
  cta_title: 'Logout',
  origin: 'cancelSubscription',
}

const CancelSubscriptionPassionsPendingTransactionContainerViewed = {
  object_name: 'CancelSubscriptionPendingPassionsTransactionContainer',
  screen: 'cancelSubscriptionConfirmation',
  screen_name: 'cancelSubscriptionConfirmation',
  origin: 'cancelSubscription',
}

const CancelSubscriptionNoBankLinkedContainerViewed = {
  object_name: 'CancelSubscriptionNoBankLinkedContainerContainer',
  screen: 'cancelSubscriptionConfirmation',
  screen_name: 'cancelSubscriptionConfirmation',
  origin: 'cancelSubscription',
}

export {
  CancelSubscriptionScreenViewed,
  CancelSubscriptionGetStartedButtonTapped,
  CancelSubscriptionConfirmationButtonTapped,
  CancelSubscriptionCancelButtonTapped,
  CancelSubscriptionConfirmButtonTapped,
  CancelSubscriptionDoneScreenViewed,
  CancelSubscriptionDoneCTA,
  CancelSubscriptionConfirmationScreenViewed,
  CancelSubscriptionPassionsPendingTransactionContainerViewed,
  CancelSubscriptionNoBankLinkedContainerViewed,
}
